import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { z } from "zod";
import type { PayRequestId } from "../pay-request-id";
import type { PayRequestEvent } from "./_pay-request.event";
import { payRequestEventIdFactory } from "./_pay-request.event-id";
import { payRequestEventSchemaFactory } from "./_pay-request.event.schema-factory";

const payRequestExpiredEventZodObject = payRequestEventSchemaFactory(
    "PAY_REQUEST_EXPIRED_EVENT",
    z.object({
        expiredAt: isoAndUnixZodSchema,
        type: z.literal("PAY_REQUEST_EXPIRED_EVENT"),
    }),
);
type PayRequestExpiredEvent = z.infer<typeof payRequestExpiredEventZodObject>;
const payRequestExpiredEventZodSchema: z.ZodSchema<PayRequestExpiredEvent> =
    payRequestExpiredEventZodObject;

type PayRequestExpiredEventFactoryParams = {
    payRequestId: PayRequestId;
    data: PayRequestExpiredEvent["data"];
    paymentFor: PayRequestEvent["paymentFor"];
    version: number;
};
const payRequestExpiredEventFactory = (
    params: PayRequestExpiredEventFactoryParams,
) => {
    const now = nowIsoAndUnix();
    const event: PayRequestExpiredEvent = {
        _id: payRequestEventIdFactory(),
        _type: "PAY_REQUEST_EVENT",
        _createdAt: now,
        _happenedAt: now,
        _version: params.version,
        type: "PAY_REQUEST_EXPIRED_EVENT",
        data: params.data,
        payRequestId: params.payRequestId,
        paymentFor: params.paymentFor,
    };
    return payRequestExpiredEventZodSchema.parse(event);
};
export {
    payRequestExpiredEventFactory,
    payRequestExpiredEventZodObject,
    payRequestExpiredEventZodSchema,
};
export type { PayRequestExpiredEvent };
